import { Controller } from "stimulus"

// Connects to data-controller="pix-modal"
export default class extends Controller {
  static values = { autoOpen: Boolean }

  connect() {
    if (this.autoOpenValue) this.open()
  }

  open() {
    // Semantic UI detaches #pix_modal into a body-level dimmer on show
    // (default `detachable: true`), so it's resolved by id here — like
    // contact_advertiser_controller.js does — rather than via a Stimulus
    // target, which stops matching once the node moves outside this
    // controller's original DOM subtree.
    $("#pix_modal").modal("show")
  }
}
